import { useOnline } from "@vueuse/core";
import { useSizingsManifoldMutation } from "gql/api";
import type { Scenario, Sizing } from "@/composables/forms/formTypes";
import type { AIEquipmentSuggestionOption } from "@/libs/api/aiEquipmentSuggestions";
import { buildRecommendedSizing } from "@/libs/ai/createRecommendedSizing";
import { haltUntilCompletion } from "@/composables/exchanges/mutationLimiter";

export function useCreateRecommendedSizing() {
  const { executeMutation } = useSizingsManifoldMutation();
  const online = useOnline();
  return async (sizing: Sizing, scenario: Scenario, option: AIEquipmentSuggestionOption) => {
    const creation = buildRecommendedSizing(sizing, scenario, option);
    const result = executeMutation(creation.variables);
    await haltUntilCompletion();
    // Follow ScenarioDetail's save semantics: inspect the result only online,
    // since offline persistence/navigation uses the optimistic mutation queue.
    if (online.value) {
      const { error } = await result;
      if (error) throw error;
    }
    return creation;
  };
}
